import { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';

import { ExportTypeSelector } from './export-type-selector';
import { SimpleModal } from '../../../../../components/simple-modal/simple-modal';
import { exportPurchaseOrdersRequest } from '../../../../../store/purchase-orders/purchase-orders.actions';
import { DIALOGUE_TYPE, EXPORT_TYPE } from '../../constants/export-purchase-orders';
import { messages } from '../../messages';
import { usePurchaseOrdersGridContext } from '../../purchase-orders-grid-context';

import type { ExportType, DialogueType } from '../../constants/export-purchase-orders';
import type React from 'react';

type ExportModalProps = {
  onCloseModal: () => void;
};

export const ExportModal = ({ onCloseModal }: ExportModalProps): React.JSX.Element => {
  const dispatch = useDispatch();
  const { totalRecords, selectedIds, appliedFilters, sortState } = usePurchaseOrdersGridContext();
  const [modalDialogue, setModalDialogue] = useState<DialogueType>(DIALOGUE_TYPE.CHOOSE_EXPORT);
  const [exportType, setExportType] = useState<ExportType>(selectedIds.length > 0 ? EXPORT_TYPE.SELECTED : EXPORT_TYPE.ALL);
  const purchaseOrderIds = exportType === EXPORT_TYPE.ALL ? null : selectedIds;

  const onConfirm = useCallback(() => {
    dispatch(exportPurchaseOrdersRequest(appliedFilters, sortState, purchaseOrderIds));
    setModalDialogue(DIALOGUE_TYPE.EXPORT_IN_PROGRESS);
  }, [appliedFilters, sortState, purchaseOrderIds, dispatch]);

  const isChooseExport = modalDialogue === DIALOGUE_TYPE.CHOOSE_EXPORT;

  return (
    <SimpleModal
      actionButtonDataPendoId='purchase-order-export-modal-action'
      actionMessage={isChooseExport ? messages.exportButton : messages.close}
      cancelMessage={isChooseExport ? messages.cancel : undefined}
      headerMessage={messages.purchaseOrderExportModalTitle}
      onAction={isChooseExport ? onConfirm : onCloseModal}
      onCancel={isChooseExport ? onCloseModal : undefined}
      onClose={onCloseModal}
    >
      {isChooseExport ? (
        <ExportTypeSelector
          exportType={exportType}
          selectedCount={selectedIds.length}
          setExportType={setExportType}
          totalRecords={totalRecords}
        />
      ) : (
        <FormattedMessage {...messages.purchaseOrderExportModalStarted} />
      )}
    </SimpleModal>
  );
};
